// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__3HW6g"};